
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as SuportIconComponent } from "./suport-icon.svg";

export const SuportIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <SuportIconComponent {...props} />;
};
